import FacturaForm from '../../spa/facturasForm/FacturasForm';

export default {
    path: '/facturas/Form/:idPedido?',
    name: 'facturaForm',
    component: FacturaForm
};


// WEBPACK FOOTER //
// ./src/config/router/facturaForm.js